import React, { Component } from "react";
import { Card, Row, Col, Select, Spin, Empty, message, Typography, Tag } from "antd";
import { ShopOutlined, AppstoreOutlined, BankOutlined } from "@ant-design/icons";
import AccountHeader from '../Account/AccountHeader';
import '../Account/Account.css';
import {
  IMAGE_URL,
  GET_BIND_APARTMENT,
  GET_PRODUCT_LIST,
  GET_PROD_CATE_LIST,
  get_data_token
} from "../../config/network";
import { Link } from "react-router-dom";
import "./product.css";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

class ProductSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      productcates: [],
      departments: [],
      selectedprocate: "",
      selectdepartment: "",
      loading: true,
      productsLoading: false
    };
  }

  componentDidMount() {
    this.getDepartment();
  }

  getDepartment = async () => {
    try {
      const data = await get_data_token(GET_BIND_APARTMENT, {});
      const departmentFromApi = data.map((record, index) => {
        if (index === 0) {
          this.setState({ selectdepartment: record.organization_id });
          this.loadProductsAndCategories(record.organization_id);
        }
        return {
          value: record.organization_name,
          key: record.organization_id
        };
      });
      this.setState({ departments: departmentFromApi });
    } catch (err) {
      this.setState({ departments: [] });
      message.error("Get department error: " + err);
    } finally {
      this.setState({ loading: false });
    }
  };

  loadProductsAndCategories = async (organizationId) => {
    this.setState({ productsLoading: true });
    try {
      // Load products
      const productData = await get_data_token(GET_PRODUCT_LIST, { organizationId });
      this.setState({ products: productData.productList || [] });

      // Load product categories
      const categoryData = await get_data_token(GET_PROD_CATE_LIST, { organizationId });
      const productcateFromApi = categoryData.productcategoryList.map(productcate => ({
        value: productcate.product_cate_name,
        key: productcate.product_cate_id
      }));
      this.setState({ productcates: productcateFromApi });
    } catch (err) {
      this.setState({ products: [], productcates: [] });
      message.error("Error loading products: " + err);
    } finally {
      this.setState({ productsLoading: false });
    }
  };

  handleDepartmentChange = (value) => {
    this.setState({ selectdepartment: value, selectedprocate: "" }); // Reset category selection
    this.loadProductsAndCategories(value);
  };

  handleCategoryChange = (value) => {
    this.setState({ selectedprocate: value });
  };

  renderProductCard = (product) => (
    <Col xs={24} sm={12} md={8} lg={6} key={product.product_id} style={{ marginBottom: 16 }}>
      <Link to={`/productdetails/${product.product_id}`}>
        <Card
          hoverable
          cover={
            <div style={{ height: 200, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
              <img
                alt={product.product_name}
                src={IMAGE_URL + product.product_thumbnail}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
              />
            </div>
          }
          actions={[
            <Tag color={product.available > 0 ? 'green' : 'red'}>
              {product.available > 0 ? 'Available' : 'Out of Stock'}
            </Tag>
          ]}
        >
          <Card.Meta
            title={
              <Text ellipsis style={{ fontSize: 16, fontWeight: 'bold' }}>
                {product.product_name}
              </Text>
            }
            description={
              <Paragraph ellipsis={{ rows: 2 }} style={{ color: '#666', marginBottom: 0 }}>
                {product.product_desc}
              </Paragraph>
            }
          />
        </Card>
      </Link>
    </Col>
  );

  render() {
    const { products, productcates, departments, selectedprocate, selectdepartment, loading, productsLoading } = this.state;

    const filteredProducts = products.filter(product =>
      selectedprocate === "" || product.category_id === selectedprocate
    );

    if (loading) {
      return (
        <div>
          <div className="main">
            <AccountHeader page={"Product"} title="Product" />
            <div className="main-body" style={{ textAlign: 'center', padding: 50 }}>
              <Spin size="large" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="dashboard-container">
        <AccountHeader
          page={"Product"}
          title={<span>Product Rental</span>}
        />

        <div className="dashboard-content">
          <Card style={{ marginBottom: 24 }}>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div style={{ marginBottom: 16 }}>
                  <Title level={5} style={{ marginBottom: 8 }}>
                    <BankOutlined style={{ marginRight: 8 }} />
                    Select Organization
                  </Title>
                  <Select
                    value={selectdepartment}
                    style={{ width: '100%' }}
                    size="large"
                    onChange={this.handleDepartmentChange}
                    placeholder="Choose your organization"
                  >
                    {departments.map(dept => (
                      <Option key={dept.key} value={dept.key}>
                        {dept.value}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ marginBottom: 16 }}>
                  <Title level={5} style={{ marginBottom: 8 }}>
                    <AppstoreOutlined style={{ marginRight: 8 }} />
                    Filter by Category
                  </Title>
                  <Select
                    value={selectedprocate}
                    style={{ width: '100%' }}
                    size="large"
                    onChange={this.handleCategoryChange}
                    placeholder="All categories"
                    allowClear
                  >
                    {productcates.map(category => (
                      <Option key={category.key} value={category.key}>
                        {category.value}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
            </Row>
          </Card>

          <Card
            title={
              <div>
                <ShopOutlined style={{ marginRight: 8 }} />
                Available Products
                <Tag color="blue" style={{ marginLeft: 8 }}>
                  {filteredProducts.length} items
                </Tag>
              </div>
            }
            bordered
          >
            {productsLoading ? (
              <div style={{ textAlign: 'center', padding: 50 }}>
                <Spin size="large" />
              </div>
            ) : filteredProducts.length > 0 ? (
              <Row gutter={[16, 16]}>
                {filteredProducts.map(this.renderProductCard)}
              </Row>
            ) : (
              <Empty
                description="No products available"
                style={{ padding: 50 }}
              />
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default ProductSelect;
